import serializeLink from './serialize-link'

export default function serializeCta(locale, link, label) {
  return label
    ? {
        ...serializeLink(link, locale),
        children: label,
      }
    : null
}
